module.exports = __webpack_public_path__ + "static/media/platform_with_robust_features_bg.32826097.png";